// pages/InspGreet.js
import { Link } from 'react-router-dom';
import Breadcrumbs from '../components/Breadcrumbs';

export default function InspGreet() {
  return (
    <div className="container" dir="rtl">
      <Breadcrumbs
        items={[
          { to: '/tractates', label: 'מסכתות' },
          { label: 'ברכת המפמ"ר' },
        ]}
      />

      <div className="toolbar toolbar--center">
        <h2 style={{ marginInlineStart: 0 }}>ברכת המפמ"ר</h2>
      </div>

      <p className="center" style={{ marginTop: '.5rem' }}>
        <Link to="/tractates">חזרה למסכתות</Link>
      </p>

      <div className="stack-3" style={{ marginTop: '1.25rem' }}>
        <section>
          <h3 style={{ margin: 0 }}>אתר "פותח שערים"</h3>
          <p style={{ marginTop: '.5rem' }}>
            אני מברך בחום על האתר החדש "פותח שערים – הבית של מורי הגמרא בחמ&quot;ד".
            האתר הוא בשורה של ממש לעולם הוראת התלמוד בחמ&quot;ד. האתר מבקש להעמיד לרשות
            המורים כלים מגוונים להוראה שיטתית ומעמיקה של הגמרא, תוך דגש מיוחד על פיתוח
            הלומד העצמאי ועל החיבור הפנימי אל לב הסוגיה. בכך, האתר שותף נאמן ליעדים
            החינוכיים של לימוד התורה בדורנו – להאיר את דרך הלימוד, לקרב את התלמידים אל
            עולמה של הגמרא, ולהעמיק את חוויית הלמידה כחוויה משמעותית ורוחנית.
          </p>
          <p>
            "פותח שערים" איננו רק מאגר של חומרים, אלא בית מקצועי תומך למורי הגמרא בחמ&quot;ד.
            הוא נותן מענה לצורך אמיתי של מורים ומורות, ומסייע בעבודת הקודש של חינוך תלמידינו
            לאהבת התורה ולמחויבות אליה.
          </p>
          <p>
            אני מאחל כי האתר יהווה מקור השראה, שותפות ומקצועיות לכל מורי הגמרא, ויתרום רבות לקידום
            ההוראה ולהעמקת החיבור של התלמידים עם לימוד הגמרא.
          </p>
          <p style={{ marginTop: '1rem' }}>
            בברכת התורה,<br />
            הרב מנחם קליין<br />
            מפקח מרכזי תושב&quot;ע ותלמוד – חמ&quot;ד
          </p>
        </section>
      </div>
    </div>
  );
}
